import { useState } from 'react';
import { Outlet } from 'react-router';

import { useUserInfo, isStoreManager } from '~domains/auth';

import { useIsDesktop } from '~shared/lib/responsive';
import { Container } from '~shared/ui/layout';

import { Typography } from '@breezeventures/ui-kit/typography';

import { TransactionsTabs } from './transactions-tabs';

import { useLastVisitedTab } from '../lib/use-last-visited-tab';

export type TransactionsOutletContext = {
  headerSlot: HTMLElement | null;
};

export const TransactionsPage = () => {
  useLastVisitedTab();
  const userInfoQuery = useUserInfo();
  const [headerSlot, setHeaderSlot] = useState<HTMLElement | null>(null);
  const isDesktop = useIsDesktop();

  const showPayments = Boolean(
    userInfoQuery.data && !isStoreManager(userInfoQuery.data)
  );

  return (
    <Container>
      <div
        className={`
          box-border min-h-full w-full pt-6 pb-page-bottom-mobile
          lg:pt-10 lg:pb-16
        `}
      >
        <div
          className={`
            mb-4 flex w-full flex-wrap items-center justify-between gap-4
            lg:mb-6
          `}
        >
          <Typography.Title size="s" tag="h2">
            Reports
          </Typography.Title>
          <div className="flex flex-wrap items-center gap-3">
            <TransactionsTabs showPayments={showPayments} />
            {isDesktop && (
              <div ref={setHeaderSlot} className="flex items-center gap-2" />
            )}
          </div>
        </div>

        <Outlet context={{ headerSlot } satisfies TransactionsOutletContext} />
      </div>
    </Container>
  );
};
